/**
 * Runtime configuration that resolves service URLs based on the current browser hostname.
 * This allows accessing dev services via Tailscale (or any non-localhost hostname)
 * without changing .env files — URLs automatically adapt to the host you access from.
 */
function resolveUrl(envUrl: string, fallback: string): string {
  const url = envUrl || fallback
  if (typeof window === 'undefined') return url
  const { hostname, protocol } = window.location
  if (hostname === 'localhost' || hostname === '127.0.0.1') return url
  const hosted = url.replace('localhost', hostname).replace('127.0.0.1', hostname)
  // The page is served over HTTPS (e.g. via Tailscale/tunnel), so an insecure
  // http:// or ws:// target would be killed by the browser as mixed content.
  // Upgrade the scheme to match the page so sync requests aren't blocked.
  if (protocol === 'https:') {
    return hosted.replace(/^http:\/\//, 'https://').replace(/^ws:\/\//, 'wss://')
  }
  return hosted
}

export const API_URL = resolveUrl(import.meta.env.VITE_MOLY_API, 'http://localhost:5163')
export const WS_URL = resolveUrl(import.meta.env.VITE_WS_URL, 'ws://localhost:8787/ws')
export const COLLAB_URL = resolveUrl(import.meta.env.VITE_COLLAB_URL, 'ws://localhost:1234')
/** Better Auth server (moly-api). Endpoints live under `${AUTH_URL}/auth`. */
export const AUTH_URL = resolveUrl(import.meta.env.VITE_AUTH_URL ?? '', 'http://localhost:8080')
